import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";
import { IDemandPayload } from "../../interface/IDemand";

export const deepDiveApi = createApi({
    reducerPath: "deepDiveApi",
    baseQuery: axiosBaseQuery(),
    endpoints: (builder)=>({
        getHistoricalForecastData: builder.mutation({
            query: (payload: IDemandPayload)=>({
                url:"/getHistoricalForecastDeepDiveData",
                method:'POST',
                data: payload
            })
        }),
        getFutureForecastDeepDiveData: builder.mutation({
            query: (payload: IDemandPayload)=>({
                url:"/getFutureForecastDeepDiveData",
                method:'POST',
                data: payload
            })
        }),
    })
});

export const { 
    useGetHistoricalForecastDataMutation,
    useGetFutureForecastDeepDiveDataMutation, 
} = deepDiveApi;